import {
  EmrAuditComment,
  EmrCalendar,
  EmrClose,
  EmrExclamationSquare,
  EmrInProcess,
  EmrRegistration,
  SiTask,
} from "@medstonetech/slate-icons";

import { Icon } from "@chakra-ui/react";
import { OrderStatus } from "enums";

const ORDER_STATUS_COLOR: Record<OrderStatus, string> = {
  Cancelled: "gray",
  Completed: "green",
  InProcess: "blue",
  Ordered: "orange",
  NeedsApproval: "yellow",
  CancellationRequested: "red",
  Administered: "purple",
  Prepared: "cyan",
  PRN: "red",
  Scheduled: "red",
};

const ORDER_STATUS_ICON: Record<OrderStatus, JSX.Element> = {
  Cancelled: <Icon as={EmrClose} />,
  Completed: <Icon as={SiTask} />,
  InProcess: <Icon as={EmrInProcess} />,
  Ordered: <Icon as={EmrRegistration} />,
  NeedsApproval: <Icon as={EmrExclamationSquare} />,
  CancellationRequested: <Icon as={EmrAuditComment} />,
  Administered: <Icon as={SiTask} />,
  Prepared: <Icon as={EmrRegistration} />,
  PRN: <Icon as={EmrRegistration} />,
  Scheduled: <Icon as={EmrCalendar} />,
};

export { ORDER_STATUS_COLOR, ORDER_STATUS_ICON };
